module.exports = __webpack_public_path__ + "static/media/qualification-4.cc97dec2.svg";